module.exports = __webpack_public_path__ + "static/media/jcie.70e345d4.png";